import {
  CheckAuthResponse,
  EmailLoginCredentials,
  EmailRegisterCredentials,
} from '@/types/auth';
import { Response } from '@/types/response';
import { Lang, User } from '@/types/user';
import { api, getCsrfToken } from '@/utils/axios';

export const emailLogin = async (
  credentials: EmailLoginCredentials,
): Promise<Response> => {
  await getCsrfToken();
  return await api.post('/app-web/auth/login', credentials);
};

export const SocialLogin = async (
  provider: string,
): Promise<Response<string>> => {
  await getCsrfToken();
  const res = await api.get(`/app-web/auth/social/${provider}`);
  return res.data;
};

export const SocialLoginCallback = async (
  provider: string,
  code?: string,
): Promise<Response<User>> => {
  await getCsrfToken();
  const url = code
    ? `/app-web/auth/social/${provider}/callback?code=${code}`
    : `/app-web/auth/social/${provider}/callback`;
  const res = await api.get(url);
  return res.data;
};

export const emailRegister = async (
  credentials: EmailRegisterCredentials,
): Promise<Response> => {
  await getCsrfToken();
  const res = await api.post('/app-web/auth/register', credentials);
  return res.data;
};

export const logout = async (): Promise<Response> => {
  const res = await api.post('/app-web/auth/logout');
  return res.data;
};

export const checkAuth = async (): Promise<Response<CheckAuthResponse>> => {
  const res = await api.get('/app-web/auth/check');
  return res.data;
};

export const UpdateAuthUser = async (user: User): Promise<Response<User>> => {
  const res = await api.put('/app-web/users/auth', user);
  return res.data;
};

export const updateAuthUserAvatar = async (
  avatar: string,
): Promise<Response<User>> => {
  const res = await api.put('/app-web/users/auth/avatar', { avatar });
  return res.data;
};

export const deleteAuthUserAvatar = async (): Promise<Response<User>> => {
  const res = await api.delete('/app-web/users/auth/avatar');
  return res.data;
};

export const updateAuthUserPassword = async (data: {
  current_password: string;
  new_password: string;
  confirm_password: string;
}): Promise<Response> => {
  const res = await api.put('/app-web/users/auth/password', data);
  return res.data;
};

export const updateAuthUserLang = async (
  lang: Lang,
): Promise<Response<Lang>> => {
  const res = await api.put(`/app-web/users/auth/lang/${lang}`);
  return res.data;
};

export const deleteAuthUser = async (): Promise<Response> => {
  const res = await api.delete('/app-web/users/auth');
  return res.data;
};

export const finishOnboarding = async (): Promise<Response> => {
  const res = await api.post('/app-web/users/finish-onboarding');
  return res.data;
};

export const acceptRGPD = async (): Promise<Response<User>> => {
  const res = await api.post('/app-web/auth/accept-rgpd');
  return res.data;
};
